import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

// ========== GET EMPLOYEE LEAVE BALANCE SERVICE ==========
export const getEmployeeLeaveBalance = async (data: any) => {
	const URL = `${API_URL}GetEmployeeLeaveBalance`;
	const requestData = {
		GetEmployeeLeaveBalanceToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== CREATE LEAVE ADJUSTMENT SERVICE ==========
export const createLeaveAdjustment = async (data: any) => {
	const URL = `${API_URL}CreateLeaveAdjustment`;
	const requestData = {
		CreateLeaveAdjustmentToken: data,
	};
	return makeApiCall(URL, requestData);
};

